module.exports = __webpack_public_path__ + "img/bell.5121b72d.svg";